import React from 'react';

function SecretLetterPage() {
    return (
        <main className="SecretLetterPage">
            <section className="letter-shell">
                <p className="letter-kicker">A private letter</p>
                <h1>A aquella niña que amó cada PC que vio.</h1>
                <div className="letter-body">
                    <p>
                        A la que encontró en la tecnología un hambre, una casa y un lugar donde crecer.
                    </p>
                    <p>
                        Aunque suene enamorado, para alguien que no tuvo nada es romántico encontrar una
                        herramienta que te permite casi todo. Una computadora no era solo una máquina:
                        era una puerta, una posibilidad, una forma de imaginar otra vida.
                    </p>
                    <p>
                        Y hoy, sin entrar en detalles, se pudo. Se logró. No fue magia, no fue rápido,
                        y no es un camino para todos. Pero fue un camino posible.
                    </p>
                    <p>
                        Aprendí que crecer es difícil. Aprender también. Construir algo propio también.
                        Pero muchas cosas son difíciles, y lo importante es elegir tu difícil: día a día,
                        paso a paso.
                    </p>
                    <p>
                        Si lo hacés con amor, vas a disfrutarlo más que vivir afuera de vos misma.
                        Más que vivir en ideas, en el mañana, en lo que dirán,
                        o en ese “yo no puedo” que tantas veces intenta hablar más fuerte que tu deseo.
                    </p>
                    <p>
                        A veces tu peor obstáculo sos vos misma: tus dudas, tus excusas, tus miedos,
                        esa voz que intenta convencerte de quedarte quieta. Aprender también es mirarla
                        de frente y avanzar igual.
                    </p>
                    <p>
                        Y no hablo desde ese peligroso síndrome del impostor que intenta convencerte de que
                        no sos suficiente. Hablo de ese trabajo que no encaja, que no está alineado,
                        o donde simplemente ya no podés crecer más. Si estás ahí, armate un plan.
                        Prepará tu salida con responsabilidad, pero salí. Dejalo y no mires atrás.
                    </p>
                    <p>
                        No hace falta entenderlo todo desde el principio. No hace falta ser perfecta.
                        Hace falta volver. Insistir. Preguntar. Romper. Arreglar. Probar. Dudar. Y seguir.
                    </p>
                    <p>
                        La curiosidad puede ser una brújula. También puede llevarte de vuelta a casa.
                    </p>
                    <p>
                        Y si alguna vez te perdés, volvé a ese primer momento: una computadora enfrente,
                        los ojos abiertos,
                        y la sensación de que ahí había un mundo esperándote.
                    </p>
                </div>
                <p className="letter-signature">Con amor, para mi yo del comienzo y para quienes están empezando.</p>
            </section>
        </main>
    )
}

export default SecretLetterPage;
